import React, { useState, useEffect } from "react";
// import CrossGrayIcon from '../../common/images-new/cross-gray-icon.svg'
import ButtonBlue from "../Button/ButtonBlue";
import axios from "axios";
import { serverUrl } from "../Helpers/Config";
import Swal from "sweetalert2";
import { staticFiles } from "../Helpers/Static";
import { Card } from "../../pages/Theme";
import { tokenAuthorize } from "../Helpers/Common";

const CROSS_GRAY_ICON = staticFiles.cross;

const ModalRespond = ({ comment, listId, userId, handleClose, show }) => {
  const showHideModal = show
    ? "fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex"
    : "fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden";

  const [isLoading, setIsLoading] = useState(false);
  const [commentId, setCommentId] = useState(-1);
  const [currentComment, setCurrentComment] = useState("");
  const [isError, setisError] = useState(false);

  useEffect(() => {
    if (comment) {
      setCommentId(comment.id)
      setCurrentComment(comment.content)
    }
    else {
      setCommentId(-1)
      setCurrentComment("")
    }
  }, [comment])

  const notifyError = () => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
    });
  };

  const handleRequest = () => {
    if (currentComment !== ""){
      setIsLoading(true);
      setisError(false);
      if (commentId > 0) {
        axios
        .put(serverUrl.Teaching + "/reply/" + commentId, {
          comment_content: currentComment,
          user_id: userId,
        })
        .then((resp) => {
          setIsLoading(false);
          if (resp.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Comment has been updated",
            });
  
            setCommentId(-1)
            setCurrentComment("")
            handleClose(true);
          } else {
            notifyError();
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          setIsLoading(false);
          notifyError();
        });
      }
      else {
        axios
          .post(serverUrl.Teaching + "/reply", {
            comment_content: currentComment,
            user_id: userId,
            list_id: listId,
          })
          .then((resp) => {
            setIsLoading(false);
            if (resp.status === 200) {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Comment has been sent",
              });
  
              setCommentId(-1)
              setCurrentComment("")
              handleClose(true);
            } else {
              notifyError();
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            setIsLoading(false);
            notifyError();
          });
      }
    }else {
      setisError(true);
    }
  };

  return (
    <div className={showHideModal}>
      <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4">
        <Card className="w-80 md:w-96 bg-white px-4 md:px-8 py-5 rounded-md filter drop-shadow-md">
          <p className="text-center font-bold text-xl">Comment</p>
          <img
            className="absolute right-4 md:right-8 top-6 cursor-pointer hover:opacity-60"
            onClick={() => {
              setCommentId(-1)
              setCurrentComment("");
              handleClose(false)
            }}
            alt="Close"
            src={CROSS_GRAY_ICON}
          />
          <hr className="mt-3 border-gray-200" />
          <form className="flex flex-col mt-5 space-y-5">
            <textarea
              value={currentComment} 
              onChange={(e) => setCurrentComment(e.target.value)}
              className={ `${isError ? "border-redradius" : ""}  ${"w-full border p-2 h-48 text-black"}`}
            />
          </form>
          <div className="grid md:right-8 bottom-5 mt-4 w-full">
            {isLoading ? (
              <p className="font-semibold">Loading...</p>
            ) : (
              <ButtonBlue className="place-self-center w-full" title="COMMENT" onClick={handleRequest} />
            )}
          </div>
        </Card>
      </section>
    </div>
  );
};

export default ModalRespond;
